import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Callout, ConfirmationModal, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { helpArticles } from '~/utils/helpArticles';
import ExternalLinkButton from '../ExternalLinkButton';
import styles from './ConfirmExternallySignModal.module.scss';
export default function ConfirmExternallySignModal(props) {
    const { bulkData, hasBilledImmediatelyService, dismissModal } = props;
    const hasMultipleClients = !!bulkData && bulkData.numClients > 1;
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: confirmExternallySignModalTexts } = useLocaleKeys('components.confirmExternallySignModal');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'confirm_externally_sign_confirm'
            },
            secondaryButton: {
                name: 'confirm_externally_sign_cancel'
            }
        },
        title: bulkData ? confirmExternallySignModalTexts.titleBulk() : confirmExternallySignModalTexts.titleSingle(),
        textAlignCenter: false,
        width: "750px",
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.confirmExternallySigned,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: hasMultipleClients ? confirmExternallySignModalTexts.warrantyBulk({
                        numClients: bulkData.numClients.toString()
                    }) : confirmExternallySignModalTexts.warrantySingle()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: confirmExternallySignModalTexts.noteFollowing()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    as: "ul",
                    children: [
                        confirmExternallySignModalTexts.noDigitalSignature(),
                        confirmExternallySignModalTexts.invoicesIssued(),
                        confirmExternallySignModalTexts.clientNotNotified()
                    ].map((text, idx)=>/*#__PURE__*/ _jsxs("li", {
                            className: styles.bullet,
                            children: [
                                /*#__PURE__*/ _jsx("span", {}),
                                text
                            ]
                        }, idx))
                }),
                /*#__PURE__*/ _jsxs(Callout, {
                    children: [
                        /*#__PURE__*/ _jsx(ExternalLinkButton, {
                            openInNewTab: true,
                            href: helpArticles.onboardingExistingClients(),
                            bi: {
                                name: 'onboarding_existing_clients_learn_more'
                            },
                            children: commonTexts.buttons.learnMore()
                        }),
                        ' ',
                        confirmExternallySignModalTexts.learnMoreCallout()
                    ]
                }),
                hasBilledImmediatelyService && /*#__PURE__*/ _jsx(Callout, {
                    intent: "warning",
                    testId: "immediately-issued-warning",
                    children: confirmExternallySignModalTexts.immediateInvoiceWarning()
                })
            ]
        }),
        primaryButtonLabel: hasMultipleClients ? confirmExternallySignModalTexts.approveOnBehalfBulk() : confirmExternallySignModalTexts.approveOnBehalfSingle(),
        primaryButtonTestId: "confirm-externally-sign",
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        secondaryButtonTestId: "cancel-externally-sign",
        onPrimaryButtonClick: ()=>dismissModal(true),
        onSecondaryButtonClick: ()=>dismissModal(false)
    });
}
